/** F22: дефолты сумм формы договора. offerTerms лида (metadata.offerTerms из
 *  оффер-конструктора) побеждает исторические '200/500/250'; дефолты формы
 *  непустые, поэтому ключуемся на наличие offerTerms, а не на «пустые поля». */
export function contractDefaultsFromOfferTerms (lead) {
  const t = lead?.metadata?.offerTerms || {};
  const pick = (v, fallback) => (Number.isFinite(Number(v)) && v != null ? String(v) : fallback);
  return {
    trialAmount: pick(t.trialAmount, '200'),
    ambassadorFee: pick(t.monthlyAmount, '500'),
    incentiveAmount: pick(t.bonusAmount, '250'),
  };
}
